import { AdapterAvailabilityUpdateDto } from "../adapter-availability-update.dto";
import {
  registerDecorator,
  ValidationArguments,
  ValidationOptions,
  ValidatorConstraint,
  ValidatorConstraintInterface,
} from "class-validator";

@ValidatorConstraint({ async: true })
class IsAvailabilityShiftRequiredConstraint
  implements ValidatorConstraintInterface
{
  validate = (value: any, { object }: ValidationArguments): boolean => {
    const { available_hours, shift_id } =
      object as AdapterAvailabilityUpdateDto;
    return Number(available_hours) > 0 ? !!shift_id : true;
  };
}

export function IsAvailabilityShiftRequired(
  validationOptions?: ValidationOptions,
) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      target: object.constructor,
      propertyName,
      constraints: [],
      validator: IsAvailabilityShiftRequiredConstraint,
    });
  };
}
